import ServiceBase from './ServiceBase';

export default class OrdersService extends ServiceBase {

    getUserPledges(projectID) {
        return this.$http.get('orders/getUserPledges', { params: { projectID } });
    }

    removeUnpaidOrderItems(orderID) {
        const params = {
            orderID,
        };

        return this.$http.post('orders/removeUnpaidOrderItems', params);
    }

    getManageShippingOrderDetails(model) {
        const params = {
            applyCartShippingChanges: model.applyCartShippingChanges,
            orderCode: model.orderCode,
            projectID: model.projectID,
        };
        return this.$http.get('orders/getManageShippingOrderDetails', { params });
    }

    getAwaitingPaymentOrderDetails(model) {
        const params = {
            orderCode: model.orderCode,
            projectID: model.projectID,
        };
        return this.$http.get('orders/getAwaitingPaymentOrderDetails', { params });
    }

    getOrderDetails(model) {
        const params = {
            orderCode: model.orderCode,
            projectID: model.projectID,
        };
        return this.$http.get('orders/getOrderDetails', { params });
    }

    abortPayment(orderCode, projectID) {
        const params = {
            orderCode,
            projectID,
        };

        return this.$http.post('orders/abortPayment', params);
    }
}
